import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Workforces from './Workforces';

const mapStateToProps = (state, ownProps) => ({ ...ownProps });

export default withRouter(connect(mapStateToProps)(Workforces));
